<div *ngIf="dialogData.device as device">
  <section fxLayoutAlign="space-between center" class="device-details-header">
    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
      <sbnb-back-button
        *ngIf="showAccessCodes"
        [iconOnly]="true"
        [disableRedirect]="true"
        (click)="showAccessCodes = false"></sbnb-back-button>
      <h2 class="nomargin flex items-center">
        {{ showAccessCodes ? 'Access codes for ' : '' }} {{ device.name }}
        <ui-icon *ngIf="device.device_properties.online" [size]="24" icon="online-antenna" class="ml-2"></ui-icon>
        <ui-icon *ngIf="!device.device_properties.online" [size]="24" icon="offline-antenna" class="ml-2"></ui-icon>
      </h2>
    </div>
    <ui-close [border]="true" (click)="dialogRef.close()"></ui-close>
  </section>

  <div *ngIf="device.device_type === 'thermostat' && false" class="mt-4 text-sm" data-tour="thermostat-temp-message">
    Changes made here to temperature, mode & fan settings are temporary and will hold for 2 hours before reverting back
    to the preset mode.
  </div>

  <section class="mt-5 gap-x-2 grid grid-cols-4 max-w-106">
    <div class="flex flex-row gap-x-2 items-center">
      <ui-icon *ngIf="device.device_type === 'lock'" [size]="16" icon="padlock" class="text-night-lighter"></ui-icon>
      <ui-icon *ngIf="device.device_type === 'thermostat'" icon="griddy-temperature" class="thermostat-icon"></ui-icon>
      <span class="night text__small strong">{{ device.manufacturer }}</span>
    </div>

    <div *ngIf="device.device_type !== 'thermostat'" class="flex items-center gap-2">
      <label class="block">Power:</label>
      <sbnb-device-battery-status [battery]="device.device_properties.battery"></sbnb-device-battery-status>
    </div>

    <div *ngIf="device.device_type === 'thermostat'" class="flex flex-row items-center gap-2 -ml-8">
      <label class="block">Preset:</label>
      <div class="flex flex-col gap-6 active-preset">
        {{ device.device_properties.climate_setting.display_name }}
      </div>
    </div>

    <div *ngIf="device.device_type === 'thermostat'" class="flex flex-row items-center gap-2">
      <label class="block">Temperature:</label>
      <span class="night text__small"
        >{{
          device.temperature_scale === 'F'
            ? device.device_properties.temperature.fahrenheit
            : device.device_properties.temperature.celsius
        }}°{{ device.temperature_scale }}</span
      >
    </div>

    <div *ngIf="device.device_type === 'thermostat'" class="flex flex-row items-center gap-2">
      <label class="block">Setting:</label>
      <div class="flex items-center gap-3">
        <div
          class="flex items-center gap-2"
          *ngIf="
            device.device_properties.climate_setting.heating_point &&
            (device.temperature_scale === 'F'
              ? device.device_properties.climate_setting.heating_point.fahrenheit
              : device.device_properties.climate_setting.heating_point.celsius)
          ">
          <ui-icon icon="matches-fire" [size]="16" class="text-coral"></ui-icon>
          <span class="night text__small">
            {{
              device.temperature_scale === 'F'
                ? device.device_properties.climate_setting.heating_point.fahrenheit
                : device.device_properties.climate_setting.heating_point.celsius
            }}°{{ device.temperature_scale }}
          </span>
        </div>

        <div
          class="flex items-center gap-2"
          *ngIf="
            device.device_properties.climate_setting.cooling_point &&
            (device.temperature_scale === 'F'
              ? device.device_properties.climate_setting.cooling_point.fahrenheit
              : device.device_properties.climate_setting.cooling_point.celsius)
          ">
          <ui-icon icon="temperature-snowflake" [size]="16" class="text-aqua"></ui-icon>
          <span class="night text__small">
            {{
              device.temperature_scale === 'F'
                ? device.device_properties.climate_setting.cooling_point.fahrenheit
                : device.device_properties.climate_setting.cooling_point.celsius
            }}°{{ device.temperature_scale }}
          </span>
        </div>
      </div>
    </div>
  </section>

  <section
    *ngIf="device.device_properties.keypad && device.device_type !== 'thermostat'"
    class="mt-3 gap-x-4 grid grid-cols-3 max-w-96">
    <div class="flex flex-row gap-x-2 items-center">
      <img src="assets/iconography/keypad.svg" />
      <span class="night text__small strong">Keypad</span>
    </div>

    <div class="flex items-center gap-2">
      <label>Online:</label>
      <img
        *ngIf="device.device_properties.keypad.online"
        fxFlex="24px 0 0"
        width="24px"
        src="assets/iconography/online-antenna.svg"
        class="device-status-icon"
        alt="online" />
      <img
        *ngIf="!device.device_properties.keypad.online"
        src="assets/iconography/offline-antenna.svg"
        class="device-status-icon"
        alt="offline"
        [matTooltip]="device.issues | deviceIssuesTooltip" />
    </div>

    <div class="flex items-center gap-3">
      <label class="block">Power:</label>
      <sbnb-device-battery-status [battery]="device.device_properties.keypad.battery"></sbnb-device-battery-status>
    </div>
  </section>
  <ng-container *ngIf="!showAccessCodes">
    <section
      *ngIf="device.issues?.length > 0"
      class="errors-container"
      style="margin-top: 20px"
      fxLayout
      fxLayoutGap="12px">
      <img src="/assets/iconography/warning.svg" alt="Warning icon" />
      <div fxLayout="column" fxLayoutGap="4px">
        <div *ngFor="let issue of device.issues" class="error">
          {{ issue.message }}
          <a
            *ngIf="issue.code === 'device_disconnected'"
            href="https://help.hospitable.com/en/articles/6535385-faqs-troubleshooting-smart-locks"
            target="_blank"
            class="link-emphasized">
            See here to learn more.
          </a>
        </div>
      </div>
    </section>

    <section
      *ngIf="device.device_type !== 'thermostat'"
      style="margin-top: 20px"
      class="rule__section-container"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center">
      <h3 class="nomargin">Status</h3>

      <div fxFlex fxLayoutAlign="end center" fxLayoutGap="8px" [class.disabled]="changingLockStatus">
        <mat-spinner *ngIf="changingLockStatus" diameter="16"></mat-spinner>
        <span
          *ngIf="!changingLockStatus"
          [class.grass-darker]="device.device_properties.locked"
          [class.night]="!device.device_properties.locked"
          class="text__small strong">
          {{ device.device_properties.locked ? 'Locked' : 'Unlocked' }}
        </span>
        <mat-slide-toggle
          [disabled]="!canLock || !(hasWritePermission$ | async)"
          [matTooltip]="!(hasWritePermission$ | async) ? 'You do not have permission to edit this code' : null"
          [checked]="device.device_properties.locked"
          (change)="onDeviceLockToggled($event)"></mat-slide-toggle>
      </div>
    </section>

    <section
      *ngIf="device.codes_count && device.device_type !== 'thermostat'"
      class="rule__section-container"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center">
      <div
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="36px"
        fxLayout.lt-md="column"
        fxLayoutGap.lt-md="4px"
        fxLayoutAlign.lt-md="start start">
        <h3 class="nomargin">Access codes</h3>
        <span class="text__small night-lighter">
          {{ device.codes_count }} access code{{ device.codes_count > 1 ? 's' : '' }}
        </span>
      </div>

      <div fxFlex fxLayoutAlign="end center">
        <sbnb-button size="mini" type="secondary" (click)="showAccessCodes = true">View codes</sbnb-button>
      </div>
    </section>

    <section *ngIf="device.device_type !== 'thermostat'" class="rule__section-container flex flex-row justify-between">
      <h3 class="nomargin">Settings</h3>

      <div>
        <sbnb-button *ngIf="hasWritePermission$ | async" type="secondary" size="mini" (clicked)="onEditClicked()">
          Edit
        </sbnb-button>
      </div>
    </section>

    <div *ngIf="device.device_type !== 'thermostat'" class="flex flex-col md:flex-row gap-3">
      <section class="flex items-center gap-3">
        <label>Low battery threshold:</label>
        <span class="text__small">{{ device.device_properties.battery.threshold }}%</span>
      </section>
      <section class="flex items-center gap-3">
        <label>Code length:</label>
        <span class="text__small">{{ device.code_length }}</span>
      </section>

      <section class="flex items-center gap-3">
        <label>Guest access:</label>
        <span class="text__small">{{ device.guest_access ? 'Yes' : 'No' }}</span>
      </section>
    </div>

    <!-- Thermostat section -->
    <section *ngIf="device.device_type === 'thermostat' && false" class="mt-5 rule__section-container">
      <div class="flex items-center gap-8">
        <h3 class="nomargin">Temperature</h3>

        <div class="flex flex-col flex-grow">
          <div class="flex items-center gap-8 justify-end">
            <div
              class="flex flex-col"
              *ngIf="
                device.device_properties.climate_setting.mode.toLowerCase() === 'heat' ||
                device.device_properties.climate_setting.mode.toLowerCase() === 'heat_cool'
              ">
              <label class="mb-1 text-[10px] setpoint">Heating set-point</label>
              <mat-form-field class="w-20 nopadding input__mini nomargin" appearance="outline">
                <input
                  name="number"
                  class="nopadding text-center"
                  [(ngModel)]="device.device_properties.climate_setting.heating_point.fahrenheit"
                  (ngModelChange)="onTemperatureChange('heating_change')"
                  [disabled]="changingThermostatSettings || !device.device_properties.online"
                  type="number"
                  step="1"
                  pattern="^[0-9]+$"
                  matInput
                  [placeholder]="0"
                  min="device.device_properties.supported_temperatures.min_heating_set_point_fahrenheit"
                  min="device.device_properties.supported_temperatures.min_heating_set_point_fahrenheit"
                  max="device.device_properties.supported_temperatures.max_heating_set_point_fahrenheit"
                  data-tour="temperature-input-heating" />
              </mat-form-field>
            </div>

            <div
              class="flex flex-col"
              *ngIf="
                device.device_properties.climate_setting.mode.toLowerCase() === 'cool' ||
                device.device_properties.climate_setting.mode.toLowerCase() === 'heat_cool'
              ">
              <label class="mb-1 text-[10px] setpoint">Cooling set-point</label>
              <mat-form-field class="w-20 nopadding input__mini nomargin" appearance="outline">
                <input
                  name="number"
                  class="nopadding text-center"
                  [(ngModel)]="device.device_properties.climate_setting.cooling_point.fahrenheit"
                  (ngModelChange)="onTemperatureChange('cooling_change')"
                  [disabled]="changingThermostatSettings || !device.device_properties.online"
                  type="number"
                  step="1"
                  pattern="^[0-9]+$"
                  matInput
                  [placeholder]="0"
                  min="device.device_properties.supported_temperatures.min_cooling_set_point_fahrenheit"
                  max="device.device_properties.supported_temperatures.max_cooling_set_point_fahrenheit"
                  data-tour="temperature-input-cooling" />
              </mat-form-field>
            </div>
          </div>

          <div
            *ngIf="
              ((device.device_properties.climate_setting.mode.toLowerCase() === 'heat' ||
                device.device_properties.climate_setting.mode.toLowerCase() === 'heat_cool') &&
                device.device_properties.climate_setting.heating_point.fahrenheit <
                  device.device_properties.supported_temperatures.min_heating_set_point_fahrenheit) ||
              ((device.device_properties.climate_setting.mode.toLowerCase() === 'cool' ||
                device.device_properties.climate_setting.mode.toLowerCase() === 'heat_cool') &&
                device.device_properties.climate_setting.cooling_point.fahrenheit <
                  device.device_properties.supported_temperatures.min_cooling_set_point_fahrenheit)
            "
            class="text-warning-500 text-xs mt-1 flex justify-end">
            <div>Value is not supported</div>
          </div>
        </div>
      </div>
    </section>

    <section
      *ngIf="device.device_type === 'thermostat' && false"
      style="margin-top: 20px"
      class="rule__section-container"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center">
      <h3 class="nomargin">Mode</h3>

      <div fxFlex fxLayoutAlign="end center" fxLayoutGap="8px">
        <button
          *ngFor="let mode of device.device_properties.available_hvac_mode_settings"
          [ngClass]="{
            'active-mode': device.device_properties.climate_setting.mode.toLowerCase() === mode.toLowerCase(),
            'opacity-50 cursor-not-allowed': !device.device_properties.online || changingThermostatSettings
          }"
          (click)="onThermostatModeChange(mode)"
          [disabled]="changingThermostatSettings || !device.device_properties.online"
          [matTooltip]="!device.device_properties.online ? 'Device is offline' : ''"
          class="mode-button"
          data-tour="hvac-mode-button">
          {{ mode.toUpperCase() }}
        </button>
      </div>
    </section>

    <section
      *ngIf="device.device_type === 'thermostat' && false"
      style="margin-top: 20px"
      class="rule__section-container"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center">
      <h3 class="nomargin">Fan</h3>

      <div
        fxFlex
        fxLayoutAlign="end center"
        fxLayoutGap="8px"
        [class.disabled]="changingLockStatus || device.device_properties.climate_setting.mode.toLowerCase() === 'off'">
        <button
          *ngFor="let mode of device.device_properties.available_fan_mode_settings"
          [ngClass]="{
            'active-mode': device.device_properties.climate_setting.fan_mode.toLowerCase() === mode.toLowerCase(),
            'opacity-50 cursor-not-allowed': !device.device_properties.online || changingThermostatSettings
          }"
          (click)="onFanModeChange(mode)"
          [disabled]="changingLockStatus || !device.device_properties.online"
          [matTooltip]="!device.device_properties.online ? 'Device is offline' : ''"
          class="mode-button"
          data-tour="fan-mode-button">
          {{ mode.toUpperCase() }}
        </button>
      </div>
    </section>

    <section
      style="margin-top: 20px"
      class="rule__section-container"
      fxLayout
      fxLayoutGap="32px"
      fxLayoutAlign="start center">
      <h3 class="nomargin">Properties</h3>
      <div fxFlex fxLayoutAlign="end center">
        <sbnb-button
          *ngIf="(hasWritePermission$ | async) && device.device_type === 'thermostat'"
          type="secondary"
          size="mini"
          (clicked)="onEditClicked()">
          Edit
        </sbnb-button>
      </div>
    </section>

    <div *ngIf="device.properties?.length > 0" class="property__container mt-5">
      <div
        *ngFor="let property of device.properties"
        class="property mb-4"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="14px"
        [routerLink]="property?.id && ['/properties/property', property.id, 'merge-match']"
        [class.link-emphasized]="property?.id"
        data-element="device-property-link"
        (click)="property?.id && dialogRef.close()">
        <img class="property-image" [src]="property.picture" />
        <span>{{ property.name }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showAccessCodes">
    <ui-loading-spinner *ngIf="loadingAccessCodes" class="mt-6"></ui-loading-spinner>
    <ng-container *ngIf="accessCodes$ | async as accessCodes">
      <div *ngIf="!loadingAccessCodes" class="access-codes">
        <div
          *ngFor="let code of accessCodes.data"
          class="access-code"
          fxLayout
          fxLayoutAlign="space-between center"
          fxLayoutGap="12px"
          (click)="openCodeModal(code)">
          <span fxFlex>{{ code.name }}</span>

          <div fxFlex fxLayoutGap="24px">
            <span *ngIf="code.start" class="text__small">{{ code.start | date: DATE_FORMAT }}</span>

            <span *ngIf="code.end" class="text__small">{{ code.end | date: DATE_FORMAT }}</span>
          </div>

          <span
            [class]="'pincode pincode__default code-status-' + (code | codeStatusColor)"
            [matTooltip]="(code | codeStatus)?.name">
            {{ code.code }}
          </span>
        </div>
      </div>
      <sbnb-pagination
        *ngIf="!loadingAccessCodes && accessCodes.meta.pagination?.page_numbers?.total_pages > 1"
        position="end"
        [pageCount]="accessCodes.meta.pagination.page_numbers.total_pages"
        [currentPage]="accessCodes.meta.pagination.page_numbers.this_page"
        (pageChanged)="pageChanged($event)"></sbnb-pagination>
    </ng-container>
  </ng-container>
</div>
